import React, { useCallback, useState, PropsWithChildren } from 'react';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, useGetSchema, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';

import UsersContext from './context';
import { User } from '../types';

function UsersProvider({ children }: PropsWithChildren) {
    const [data, setData] = useState<User[]>([]);
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState<User | Object>({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res: User[]) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);
    // const saveUseGet = useGet(api, data, handleGetData, setError);
    // const get = (params: any, options: ModelOptions, updateState?: boolean) => {
    //     if (!data.length) {
    //         return saveUseGet(params, options, updateState);
    //     } else {
    //         return Promise.resolve(data);
    //     }
    // };
    const getSchema = useGetSchema(api, schema, setSchema, setError);

    const handleSetData = useCallback((item: User, newData: User[]) => {
        setData(newData);
        setSelected(item);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id: User['_id'], newData: User[]) => {
        setData(newData);
        setSelected({});
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <UsersContext.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete
            }}
        >
            {children}
        </UsersContext.Provider>
    );
}

export default UsersProvider;
